import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import footer_logo from '../assets/cafe/logo_big.png';
import instagram_icon from '../assets/cafe/instagram_icon.png';
import pintester_icon from '../assets/cafe/pintester_icon.png';
import whatsapp_icon from '../assets/cafe/whatsapp_icon.png';

const Footer = () => {
    return (
        <div className="footer">
            {/* <div className="footer-logo">
                <img src={footer_logo} alt="" />
                <p className="title-font">Inioli</p>
            </div>
            <ul className="footer-links footer-links-md">
                <li>Company</li>
                <li>Products</li>
                <li>Offices</li>
                <li>About</li>
                <li>Contact</li>
            </ul>
            <div className="footer-social-icon">
                <div className="footer-icons-container">
                    <img src={instagram_icon} alt="" />
                </div>
                <div className="footer-icons-container">
                    <img src={pintester_icon} alt="" />
                </div>
                <div className="footer-icons-container">
                    <img src={whatsapp_icon} alt="" />
                </div>
            </div> */}
            <div className="footer-links footer-links-md">
                <div>Address&nbsp;:&nbsp;</div>
                <div>
                    <Link className="footer-color" to="https://maps.app.goo.gl/kJJTGc7kUn7ELj7YA?g_st=ic" target="_blank">
                        East Brunswick, NJ - 08816
                    </Link>
                </div>
                <div>&nbsp;&nbsp;&nbsp;</div>
                <div>Contact&nbsp;:&nbsp;
                    <Link className="footer-color" to="https://wa.me/14249778995" target="_blank">
                        +1 424-977-8995
                    </Link>
                </div>
            </div>
            <div className="footer-copyright">
                <hr />
                <p>Copyright @ 2024 - All Rights Reserved.</p>
            </div>
        </div>
    )
}

export default Footer;